import { Overrides } from '@material-ui/core/styles/overrides'

import { greyPalette, masmovilPalette, llamayaPalette, llamayaLink } from './colors'
import { fonts } from './fonts'

const commonButtonOverride: Overrides = {
  MuiButton: {
    root: {
      borderRadius: '20px',
      padding: '12px 16px',
      lineHeight: 1,
      fontSize: fonts.size.base,
      fontWeight: 'bold',
    },
    outlined: {
      padding: '12px 16px',
    },
    outlinedSecondary: {
      border: `1px solid #333333`,
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
      color: greyPalette[900],
      '&:hover': {
        backgroundColor: greyPalette[100],
        borderColor: '#333333',
      },
      '&.Mui-disabled': {
        color: greyPalette[500],
        backgroundColor: '#ffffff',
        boxShadow: 'none',
      },
    },
    sizeSmall: {
      fontSize: fonts.size.small,
      borderRadius: '16px',
      padding: '8px 12px',
      lineHeight: 1.14,
      height: '32px',
    },
  },
}

export const masmovilButtonOverride: Overrides = {
  MuiButton: {
    ...commonButtonOverride.MuiButton,
    contained: {
      '&.Mui-disabled': {
        backgroundColor: masmovilPalette.secondary.disabled,
        color: masmovilPalette.secondary.contrastText,
      },
    },
    containedSecondary: {
      '&.Mui-disabled': {
        backgroundColor: masmovilPalette.secondary.disabled,
        color: masmovilPalette.secondary.contrastText,
      },
    },
  },
}

export const llamayaButtonOverride: Overrides = {
  MuiButton: {
    ...commonButtonOverride.MuiButton,
    contained: {
      ...commonButtonOverride?.MuiButton?.contained,
      '&.Mui-disabled': {
        backgroundColor: llamayaPalette.primary.disabled,
        color: llamayaPalette.primary.contrastText,
      },
    },
    containedSecondary: {
      '&.Mui-disabled': {
        backgroundColor: llamayaPalette.secondary.disabled,
        color: llamayaPalette.secondary.contrastText,
      },
    },
    outlinedSecondary: {
      ...commonButtonOverride?.MuiButton?.outlinedSecondary,
      borderColor: llamayaLink.main,
      color: llamayaLink.main,
      '&:hover': {
        backgroundColor: '#f7e8f9',
        borderColor: llamayaLink.main,
      },
    },
  },
}
